import { CommonConfirmationMessage } from 'gemlux-common-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { LOGIN_ROUTE } from '../../utils/routes';
import { handleGoBackTo } from '../../utils/general.utils';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { validatePaymentMethodSuccess } from '../../api/generalApi';
import { subscriptionActions } from '../../redux/subscription/subscriptionSlice';

function AccountActivationSuccess() {
  const signUpData = useAppSelector((state: RootState) => state.auth.signUpData);
  const dispatch = useAppDispatch();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const title = queryParams.get('title') || 'Account Created!';
  const description =
    queryParams.get('description') ||
    'Your subscription is now active. Use your created login details to access ' +
      'your account and enjoy all the amazing features.';

  const handlePaymentValidation = async () => {
    try {
      if (signUpData.businessEmail) {
        await validatePaymentMethodSuccess(signUpData.businessEmail);
      } else {
        console.error('Business email is undefined');
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const paymentIntentId = queryParams.get('payment_intent');

    if (paymentIntentId) {
      dispatch(subscriptionActions.confirmPaymentAndUnlockAsync({ paymentIntentId }));
    } else {
      console.error('Payment Intent ID is missing');
    }
  }, []);

  useEffect(() => {
    handlePaymentValidation();
  }, []);

  const navigate = useNavigate();
  return (
    <CommonConfirmationMessage
      title={title}
      description={description}
      button="Sign In Now!"
      onClick={() => handleGoBackTo(navigate, LOGIN_ROUTE)}
    />
  );
}
export default AccountActivationSuccess;
